import { put, call, take, fork } from 'redux-saga/effects'
import { sectionPatchService } from 'src/api/course'
//import { questionPatchSuccess } from '../../reducers/question/action'
import { patchSectionSuccess } from 'src/reducers/course/action'
import { PATCH_SECTION } from 'src/reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* sectionPatchFlow(payload) {
  try {
    const { content, callback } = payload

    yield call(sectionPatchService, content)
    yield put(patchSectionSuccess(content))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* sectionWatcher() {
  while (true) {
    const action = yield take(PATCH_SECTION)
    const { payload } = action

    yield fork(generalSaga, sectionPatchFlow, payload, false)
  }
}
